import React, { useEffect } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import LeadForm from './LeadForm';
import ProductImage from './ProductImage';
import { products } from './productData';
import { whatsappUrl } from './WhatsAppButton';

function ProductDetail() {
  const { slug } = useParams();
  const product = products.find((item) => item.slug === slug);

  useEffect(() => {
    if (product) {
      document.title = `${product.name} | Zyvora Life Sciences 9`;
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) metaDescription.setAttribute('content', `${product.description} Benefits, ingredients, usage, packaging sizes, and inquiry options from Zyvora Life Sciences 9.`);
    }
  }, [product]);

  if (!product) return <Navigate to="/products" replace />;

  return (
    <main className="product-detail-page">
      <section className="section product-detail-hero">
        <div className="content product-detail-grid">
          <div>
            <Link to="/products" className="text-link">← Back to Products</Link>
            <p className="eyebrow">{product.category}</p>
            <h1>{product.name}</h1>
            <p className="hero-lead">{product.description}</p>
            <div className="cta-group">
              <a href={whatsappUrl} target="_blank" rel="noreferrer" className="btn gold">WhatsApp Product Inquiry</a>
              <Link to="/contact" className="btn secondary">Request Bulk Quote</Link>
            </div>
          </div>
          <div className="detail-image-card">
            <ProductImage product={product} className="detail-product-image" variant="detail" />
          </div>
        </div>
      </section>

      <section className="section light-bg">
        <div className="content detail-info-grid">
          <article className="card detail-card">
            <h2>Benefits</h2>
            <ul className="check-list">{product.benefits.map((item) => <li key={item}>{item}</li>)}</ul>
          </article>
          <article className="card detail-card">
            <h2>Ingredients</h2>
            <ul className="check-list">{product.ingredients.map((item) => <li key={item}>{item}</li>)}</ul>
          </article>
          <article className="card detail-card">
            <h2>Usage Instructions</h2>
            <p>{product.usage}</p>
          </article>
          <article className="card detail-card">
            <h2>Packaging Sizes</h2>
            <ul className="check-list">{product.packaging.map((item) => <li key={item}>{item}</li>)}</ul>
          </article>
        </div>
      </section>

      <section className="section">
        <div className="content dealer-panel">
          <div>
            <p className="eyebrow">Inquiry CTA</p>
            <h2>Need dosage, pricing, or dealership information?</h2>
            <p>Share your requirement and our team will help with product literature, usage guidance, and bulk supply information.</p>
          </div>
          <LeadForm formType={`Product Inquiry - ${product.name}`} submitLabel="Send Product Inquiry" compact />
        </div>
      </section>
    </main>
  );
}

export default ProductDetail;
